import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "./ui/alert-dialog";
import { etapeOf } from "../lib/constants";

export const Field = ({ label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-xs font-medium uppercase tracking-wider text-[var(--kc-muted)]">{label}</Label>
    {children}
  </div>
);

export const SelectField = ({ value, onChange, options, testId, placeholder }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="bg-white"><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.id;
        const l = typeof o === "string" ? o : o.label;
        return <SelectItem key={v} value={v}>{l}</SelectItem>;
      })}
    </SelectContent>
  </Select>
);

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="kc-fade mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
    <div>
      {eyebrow && <p className="kc-eyebrow mb-3">{eyebrow}</p>}
      <h1 className="font-display text-3xl font-semibold tracking-tight text-[var(--kc-navy)] sm:text-4xl">{title}</h1>
      {description && <p className="mt-2 max-w-2xl text-sm text-[var(--kc-muted)] sm:text-base">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
  </div>
);

export const StageBadge = ({ etape, testId }) => {
  const e = etapeOf(etape);
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium"
      style={{ color: e.color, borderColor: `${e.color}40`, background: `${e.color}10` }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: e.color }} />{e.label}
    </span>
  );
};

export const Chip = ({ children }) => (
  <span className="rounded-md bg-[var(--kc-sand)] px-2 py-0.5 text-[11px] font-medium text-[var(--kc-navy)]">{children}</span>
);

export const Panel = ({ title, action, children, className = "", testId }) => (
  <section data-testid={testId} className={`kc-card ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between border-b border-[var(--kc-line)] px-6 py-4">
        <h2 className="font-display text-base font-semibold text-[var(--kc-navy)] md:text-lg">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-6">{children}</div>
  </section>
);

export const Empty = ({ children }) => (
  <p className="rounded-md border border-dashed border-[var(--kc-line)] px-4 py-6 text-center text-sm text-[var(--kc-muted)]">{children}</p>
);

export const ConfirmDelete = ({ onConfirm, trigger, title = "Supprimer cet élément ?", description = "Cette action est définitive." }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-delete-cancel">Annuler</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete-confirm" onClick={onConfirm} className="bg-[#B42318] hover:bg-[#912018]">Supprimer</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
